import React, { useState } from "react"
import { Button, Col, Input, message, Modal, Row, Spin } from "antd"
import TrayIdModal from "./TrayIdModal"
import { EditOutlined, LoadingOutlined } from "@ant-design/icons"
import { useEffect } from "react"
import "./photoOnly.css"
import { useParams } from "react-router-dom"
import { STATUS } from "../interface/interface"
import { saveExtractedData } from "../../api/trayTable/TrayTableMethods"
import { getBpProgression } from "../../api/BPTable/BPTableMethods"

const COUNT: number[] = [15, 10, 5]

const PhotoOnly = (props: { qrText: string | undefined, setCropImage: any, OLPN: string | undefined, setShowImage, setValidated, setProgression, progress, refresh, tray, setTray, trayID, setTrayID }) => {
  const [trayModal, setTrayModal] = useState<boolean>(false)
  const [trayId, setTrayId] = useState<string | undefined>(undefined)
  const [inputModal, setInputModal] = useState<boolean>(false)
  const [inputNumber, setInputNumber] = useState<number>(0)
  const [braceletNumber, setBraceletNumber] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const { bpId } = useParams()

  useEffect(() => {
    if (props.trayID.length > 0) {
      setTrayId(props.trayID)
      setTrayModal(true)
    }
  }, [props.trayID])

  const getProgression = async () => {
    if (bpId) {
      const res = await getBpProgression(bpId)
      props.setProgression(res)
    }
  }

  const validate = async () => {
    if (!props.OLPN) return message.error("L'OLPN est invalide")
    if (trayId?.length === 0) return message.error("L'identifiant de plateau ne peut pas etre vide")
    if (!navigator.onLine) return message.error("Aucune connexion. impossible de valider le plateau")
    if (braceletNumber === 0) return message.error("Le nombre de bracelet ne peut pas être égale à 0")
    const path = sessionStorage.getItem("s3Path")
    setLoading(true)
    const bpNumber: number = bpId ? bpId as unknown as number : 0
    let emptyObj: any[] = [];
    for (let i = 0; i < braceletNumber; i++)
      emptyObj.push({})
    await saveExtractedData(bpNumber, trayId, path, STATUS.SUCCESS, emptyObj, braceletNumber, props.OLPN)
    props.setValidated(true)
    getProgression()
    setLoading(false)
    message.success("Plateau validé")
    sessionStorage.removeItem("photo_only")
    props.setTrayID("")
    props.setCropImage(undefined)
    props.setShowImage(undefined)
    // if (props.refresh)
    //   window.location.reload()
  }

  return (
    <Row style={{ width: '100%' }}>
      <TrayIdModal setTrayModal={setTrayModal} trayModal={trayModal} setTrayId={setTrayId} trayId={trayId} />
      <Modal
        footer={[<Button key='cancel' onClick={() => {
          setInputModal(false)
        }}>Annuler</Button>,
        <Button key='ok' onClick={() => {
          setInputModal(false)
          setBraceletNumber(inputNumber)
        }}>Valider</Button>]}
        open={inputModal}
        onCancel={() => { setInputModal(false) }}
        onOk={() => { setInputModal(false) }}
        title="Entrer le nombre de bracelets"
      >
        <Input value={inputNumber} onChange={(e) => setInputNumber(Number(e.target.value))} type="number"></Input>
      </Modal>
      <Col xs={24} style={{ textAlign: 'center', paddingBottom: '0.5rem' }}>
        {trayId?.length === 0 ?
          <span>Aucun ID détécté</span>
          :
          <span>ID plateau: {trayId}</span>
        }
        <Button style={{ marginLeft: '0.5rem' }} onClick={() => {
          props.setTray(true)
        }}><EditOutlined /></Button>
      </Col>
      {!props.tray ?
        <>
          <Col xs={24} >
            <h3>
              Bracelets: {braceletNumber}
            </h3>
            {COUNT.map((elem) => (
              <Button key={elem} onClick={() => setBraceletNumber(elem)} className="photo-only-button" size="large">+{elem}</Button>
            ))}
            <Button className="photo-only-button" size="large" onClick={() => setInputModal(true)}>
              Autre
            </Button>
          </Col>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <Spin indicator={<LoadingOutlined className='loading-icon' />} spinning={loading}>
              <Button onClick={() => validate()} className='validate-control'>Valider</Button>
            </Spin>
          </Col>
        </>
        :
        <>
        </>
      }
    </Row>
  )
}

export default PhotoOnly